import type { CSSProperties } from "react";

import { Div, Text } from "@hopper-ui/components";
import { LoadingDots } from "./LoadingDots.tsx";
import "./TextLoading.css";

interface Props {
    delayMs: number;
    message: string;
    disableReveal?: boolean;
}

interface CustomCSSProperties extends CSSProperties {
    "--wai-text-loading-delay"?: string;
}

export const TextLoading = ({ delayMs, message, disableReveal }: Props) => {
    const textStyle: CustomCSSProperties = {
        "--wai-text-loading-delay": `${delayMs}ms`
    };

    return (
        <Div className={disableReveal ? "" : "wai-text-loading"} style={textStyle}>
            <Text fontSize="inherit" color="neutral">
                {message}
                <LoadingDots delayMs={120} />
            </Text>
        </Div>
    );
};
